import { notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { twoSectionTopWidgetQueue$key } from "~/queries/__generated__/twoSectionTopWidgetQueue.graphql";

import {
  Container,
  Primary,
  Secondary,
  StyledContentItemHomeSecondary,
  StyledContentItemSectionTopLeadSecondary,
} from "./styles";

type Props = {
  reference: twoSectionTopWidgetQueue$key;
} & ContentItemRenderVariantProps;

export const SectionTopWidgetTwo: FunctionComponent<Props> = ({
  className,
  onClick,
  reference,
}) => {
  const data = useFragment(
    graphql`
      fragment twoSectionTopWidgetQueue on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Content {
            ...homeSecondaryContentItemContent
            ...sectionTopLeadSecondaryContentItemContent
          }
        }
      }
    `,
    reference,
  );

  const items = data?.map(({ node }) => node).filter(node => notEmpty(node)) ?? [];

  if (items.length === 0) return null;

  const [leading, ...rest] = items;

  return (
    <Container className={className}>
      <Primary>
        {leading && (
          <StyledContentItemSectionTopLeadSecondary
            reference={leading}
            withComment={true}
            onClick={(entityId, urlAlias) => onClick?.(entityId, urlAlias)}
          />
        )}
      </Primary>
      {rest?.length > 0 && (
        <Secondary>
          {rest
            ?.slice(0, 4)
            ?.map((item, index) => (
              <StyledContentItemHomeSecondary
                key={index}
                reference={item}
                withComment={true}
                onClick={(entityId, urlAlias) => onClick?.(entityId, urlAlias)}
              />
            ))}
        </Secondary>
      )}
    </Container>
  );
};

SectionTopWidgetTwo.displayName = "SectionTopWidgetTwo";
